<template>
  <v-card>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        class='font-weight-light'
        v-model='search'
        append-icon='mdi-magnify'
        label='Search adoption label'
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :loading='loading'
      :headers='headers'
      :items='adoptionLabelList'
      :search='search'
      class='elevation-1 for-table-ie'
    >
      <template v-slot:top>
        <v-toolbar flat id='manageTable'>
          <v-toolbar-title class='display-1 fontcolor'>{{TABLE_TITLE}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog default v-model='addDialog' max-width='500px'>
            <template v-slot:activator='{ on }'>
              <v-btn outlined class='mb-2 fontcolor' v-on='on'>
                <v-icon dark>mdi-plus</v-icon>
                {{ADD_ADOPTION_LABEL}}
              </v-btn>
            </template>
            <template>
              <add-adoption-label
              @resetDialog='addDialog = $event'
              :userId='userId'
              >
              </add-adoption-label>
            </template>
          </v-dialog>
          <v-dialog v-if="editDialog" v-model='editDialog' max-width='500px'>
             <template>
              <edit-adoption-label
              :userId='userId'
              @resetEditDialog='editDialog = $event'
              :adoptionLabel="selectedItem"
              :selectedEditedIndex="editedIndex">
              </edit-adoption-label>
            </template>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.publisher='{ item }'>
        {{ item.publisherName }} ({{ item.publisherAcronym }})
      </template>
      <template v-slot:item.action='{ item }'>
        <v-icon text small class='mr-2' @click='editItem(item)'>mdi-border-color</v-icon>
        <v-icon v-if="item.status === 1" text small class='mr-2' @click='deleteAdoptionLabel(item)'>delete</v-icon>
      </template>
      <template v-slot:no-data>
        <p>{{NO_DATA_FOUND}}</p>
      </template>
    </v-data-table>
    <template>
      <ConfirmationBox  :dialog="deleteDialog" :confirm="confirmDelete" :btnLoader="btnLoader" :discription="dialogDiscription" :cancel="cancel" />
      <AlertBox :alertDialog="alertDialog"  :discription="alertDiscription" :cancel="closeAlertBox" />
    </template>
  </v-card>
</template>
<script>
import CONSTANTS from './../../../../config/constant'
import AddAdoptionLabel from './AddAdoptionLabel.vue'
import EditAdoptionLabel from './EditAdoptionLabel.vue'
export default {
  data: () => ({
    loading: true,
    NO_DATA_FOUND: CONSTANTS.NO_DATA_FOUND,
    TABLE_TITLE: CONSTANTS.MANAGE_ADOPTION_LABEL,
    ADD_ADOPTION_LABEL: CONSTANTS.ADD_ADOPTION_LABEL,
    search: '',
    editedIndex: -1,
    btnLoader: false,
    selectedItem: {},
    addDialog: false,
    editDialog: false,
    valid: true,
    deleteIndex: -1,
    deleteDialog: false,
    alertDialog: false,
    dialogDiscription: '',
    alertDiscription: '',
    // table headers
    headers: [
      {
        text: 'ID',
        align: 'left',
        sortable: true,
        value: 'id',
        class: 'title'
      },
      {
        text: 'Adoption Label',
        value: 'adoptionLabel',
        sortable: true,
        class: 'title'
      },
      {
        text: 'Book Abbreviation',
        value: 'abbreviation',
        class: 'title'
      },
      {
        text: 'Publisher',
        value: 'publisher',
        sortable: false,
        class: 'title'
      },
      {
        text: 'Status',
        value: 'statusText',
        sortable: false,
        class: 'title'
      },
      { text: 'Actions', value: 'action', sortable: false, class: 'title' }
    ]
  }),
  components: {
    'add-adoption-label': AddAdoptionLabel,
    'edit-adoption-label': EditAdoptionLabel,
    ConfirmationBox: () => import('../modelbox/ConfirmBox.vue'),
    AlertBox: () => import('../modelbox/AlertBox.vue')
  },
  computed: {
    // to fetch adoption label list
    adoptionLabelList () {
      return this.$store.getters['AdoptionLabelModule/fetchAdoptionLabelList']
    },
    // to get logged in user ID
    userId () {
      return this.$store.getters['AuthModule/getUserId']
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    // dispatch an action in below method to fetch publishers list
    initialize () {
      // let status = '' // by default status is empty, declare 'status' here for future use
      new Promise((resolve, reject, status) => {
        this.$store.dispatch('AdoptionLabelModule/getAdoptionLabelList', {
          resolve,
          reject,
          status
        })
      })
        .then(responseData => {
          this.loading = false
        })
        .catch(({ response }) => {
          this.loading = false
        })
    },
    editItem (item) {
      this.editedIndex = this.adoptionLabelList.indexOf(item)
      this.selectedItem = item
      this.editDialog = true
    },
    // DELETE ADOPTION LABEL CODE START HERE
    cancel () {
      this.deleteDialog = false
    },
    closeAlertBox () {
      this.alertDialog = false
    },
    deleteAdoptionLabel (item) {
      const formData = {
        userId: this.userId,
        id: item.id,
        isValidation: true
      }
      this.deleteIndex = item.id
      new Promise((resolve, reject) => {
        this.$store.dispatch('AdoptionLabelModule/validateAdoptionLabelItem', {
          resolve,
          reject,
          formData
        })
      })
        .then(responseData => {
          this.deleteDialog = true
          this.dialogDiscription = item.adoptionLabel
        })
        .catch(response => {
          this.alertDialog = true
          let message = 'A few reference(s) exist in other Entity(s), please remove all references and try again to delete ' + "'" + item.adoptionLabel + "'" + ' Adoption Label.'
          this.alertDiscription = message
        })
    },
    confirmDelete () {
      this.btnLoader = true
      const formData = { userId: this.userId, id: this.deleteIndex }
      let isPromise = new Promise((resolve, reject) => {
        this.$store.dispatch('AdoptionLabelModule/deleteAdoptionLabelItem', { resolve, reject, formData })
      })
      isPromise
        .then((response) => {
          this.deleteIndex = -1
          this.deleteDialog = false
          this.btnLoader = false
          this.$globalStates.notification.type = 'green'
          this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(response.responseMessage)
          this.$globalStates.notification.init_notifications = true
        })
        .catch((response) => {
          this.deleteIndex = -1
          this.deleteDialog = false
          this.btnLoader = false
          this.$globalStates.notification.type = 'error'
          this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(response.responseMessage)
          this.$globalStates.notification.init_notifications = true
        })
    }
  }
}
</script>
